import { makeStyles, shorthands } from '@fluentui/react-components';

export const useStyles = makeStyles({
  editVideoPageNavigation: {
    ...shorthands.padding('8px'),
  },
  tabList: {
    display: 'flex',
    ...shorthands.gap('12px'),
    flexDirection: 'column',
    alignItems: 'center',

    '& >div': {
      width: '100%',
    },
  },
  tabItemWrapper: {
    '&.selected': {
      '& .fui-Tab': {
        backgroundColor: 'rgba(246, 246, 246, 0.50)',
        ...shorthands.borderRadius('3px'),

        '::after': {
          color: '#005FB8',
        },

        '& .fui-Tab__icon, .fui-Tab__content': {
          color: '#005FB8',
        },
      },
    },
  },
  tabItem: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',

    '::after': {
      height: '18px',
      alignSelf: 'center',
    },

    '&:hover::before': {
      height: '18px',
      alignSelf: 'center',
    },

    '& .fui-Tab__content': {
      fontSize: '12px',
      '-webkit-box-orient': 'vertical',
      ...shorthands.overflow('hidden'),
      display: '-webkit-box',
      wordBreak: 'break-word',
      width: '61px',
    },

    '& .fui-Tab__content--reserved-space': {
      display: 'none',
    },
  },
});
